import axios from 'axios';
import { config } from '../config';

const API_BASE_URL = config.API_URL || '/api';

export const getCustomerAuthHeaders = () => {
  const headers = {};
  const token = localStorage.getItem('customerToken');
  const tenantId = localStorage.getItem('customerTenantId');
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (tenantId && tenantId !== 'null') {
    headers['X-Tenant-ID'] = tenantId;
  }
  return headers;
};

export const customerApi = {
  get: async (endpoint) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${endpoint}`, {
        headers: getCustomerAuthHeaders()
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error;
      } else if (error.request) {
        throw new Error('Keine Verbindung zum Server');
      } else {
        throw error;
      }
    }
  },

  post: async (endpoint, data) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${endpoint}`, data, {
        headers: getCustomerAuthHeaders(),
        maxContentLength: Infinity,
        maxBodyLength: Infinity
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error;
      } else if (error.request) {
        throw new Error('Keine Verbindung zum Server');
      } else {
        throw error;
      }
    }
  },

  put: async (endpoint, data) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${endpoint}`, data, {
        headers: getCustomerAuthHeaders(),
        maxContentLength: Infinity,
        maxBodyLength: Infinity
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error;
      } else if (error.request) {
        throw new Error('Keine Verbindung zum Server');
      } else {
        throw error;
      }
    }
  },

  delete: async (endpoint) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${endpoint}`, {
        headers: getCustomerAuthHeaders()
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error;
      } else if (error.request) {
        throw new Error('Keine Verbindung zum Server');
      } else {
        throw error;
      }
    }
  }
};
